// "use strict";var Ajaxinate=function(config){var settings=config||{},defaultSettings={pagination:".AjaxinatePagination",method:"scroll",container:".AjaxinateLoop",offset:0,loadingText:'<div class="loading"></div>',callback:null};this.settings=Object.assign(defaultSettings,settings),this.addScrollListeners=this.addScrollListeners.bind(this),this.addClickListener=this.addClickListener.bind(this),this.checkIfPaginationInView=this.checkIfPaginationInView.bind(this),this.stopMultipleClicks=this.stopMultipleClicks.bind(this),this.destroy=this.destroy.bind(this),this.containerElement=document.querySelector(this.settings.container),this.paginationElement=document.querySelector(this.settings.pagination),this.initialize()};Ajaxinate.prototype.initialize=function(){if(this.containerElement){var initializers={click:this.addClickListener,scroll:this.addScrollListeners};initializers[this.settings.method]()}},Ajaxinate.prototype.addScrollListeners=function(){this.paginationElement&&(document.addEventListener("scroll",this.checkIfPaginationInView),window.addEventListener("resize",this.checkIfPaginationInView),window.addEventListener("orientationchange",this.checkIfPaginationInView))},Ajaxinate.prototype.addClickListener=function(){this.paginationElement&&(this.nextPageLinkElement=this.paginationElement.querySelector("a"),this.clickActive=!0,this.nextPageLinkElement!==null&&this.nextPageLinkElement.addEventListener("click",this.stopMultipleClicks))},Ajaxinate.prototype.stopMultipleClicks=function(event){event.preventDefault(),this.clickActive&&(this.nextPageLinkElement.innerHTML=this.settings.loadingText,this.nextPageUrl=this.nextPageLinkElement.href,this.clickActive=!1,this.loadMore())},Ajaxinate.prototype.checkIfPaginationInView=function(){var top=this.paginationElement.getBoundingClientRect().top-this.settings.offset,bottom=this.paginationElement.getBoundingClientRect().bottom+this.settings.offset;top<=window.innerHeight&&bottom>=0&&(this.nextPageLinkElement=this.paginationElement.querySelector("a"),this.removeScrollListener(),this.nextPageLinkElement&&(this.nextPageLinkElement.innerHTML=this.settings.loadingText,this.nextPageUrl=this.nextPageLinkElement.href,this.loadMore()))},Ajaxinate.prototype.loadMore=function(){this.request=new XMLHttpRequest,this.request.onreadystatechange=function(){if(this.request.readyState===4&&this.request.status===200){var newContainer=this.request.responseXML.querySelectorAll(this.settings.container)[0],newPagination=this.request.responseXML.querySelectorAll(this.settings.pagination)[0];this.containerElement.insertAdjacentHTML("beforeend",newContainer.innerHTML),this.paginationElement.innerHTML=newPagination.innerHTML,this.settings.callback&&typeof this.settings.callback=="function"&&this.settings.callback(this.request.responseXML),this.initialize()}}.bind(this),this.request.open("GET",this.nextPageUrl),this.request.responseType="document",this.request.send()},Ajaxinate.prototype.removeClickListener=function(){this.nextPageLinkElement.addEventListener("click",this.stopMultipleClicks)},Ajaxinate.prototype.removeScrollListener=function(){document.removeEventListener("scroll",this.checkIfPaginationInView),window.removeEventListener("resize",this.checkIfPaginationInView),window.removeEventListener("orientationchange",this.checkIfPaginationInView)},Ajaxinate.prototype.destroy=function(){var destroyers={click:this.removeClickListener,scroll:this.removeScrollListener};return destroyers[this.settings.method](),this};
// var endlessScroll = null;
// document.addEventListener("DOMContentLoaded", function() {
//   initAjaxinate();
// });
// document.addEventListener("facet:update", function() {
//   setTimeout(()=>{
//     initAjaxinate();
//   }, 500)
// });

// function initAjaxinate() {
//   removeEventListeners('#AjaxinatePagination');
//   endlessScroll = new Ajaxinate({
//     container: '#AjaxinateContainer',
//     pagination: '#AjaxinatePagination',
//     callback: function() {
//     }
//   });
// }

// function removeEventListeners(selector) {
//   const el = document.querySelector(selector);
//   if (el) {
//     const clone = el.cloneNode(true);
//     el.parentNode.replaceChild(clone, el);
//   }
// }








// "use strict";

// /* ---------- Ajaxinate (same as your fixed version) ---------- */
// var Ajaxinate = function(config){
//   var settings = config || {},
//       defaultSettings = {
//         pagination: ".AjaxinatePagination",
//         method: "scroll",
//         container: ".AjaxinateLoop",
//         offset: 0,
//         loadingText: '<div class="loading"></div>',
//         callback: null
//       };
//   this.settings = Object.assign(defaultSettings, settings);
//   this.addScrollListeners = this.addScrollListeners.bind(this);
//   this.addClickListener = this.addClickListener.bind(this);
//   this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
//   this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
//   this.destroy = this.destroy.bind(this);

//   // do not cache selectors here — read them each initialize call
//   this.containerElement = document.querySelector(this.settings.container);
//   this.paginationElement = document.querySelector(this.settings.pagination);
//   this.initialize();
// };

// Ajaxinate.prototype.initialize = function(){
//   // refresh references each time initialize is called
//   this.containerElement = document.querySelector(this.settings.container);
//   this.paginationElement = document.querySelector(this.settings.pagination);

//   if (!this.containerElement) return;
//   var initializers = { click: this.addClickListener, scroll: this.addScrollListeners };
//   initializers[this.settings.method]();
// };

// Ajaxinate.prototype.addScrollListeners = function(){
//   if (!this.paginationElement) return;
//   document.addEventListener("scroll", this.checkIfPaginationInView);
//   window.addEventListener("resize", this.checkIfPaginationInView);
//   window.addEventListener("orientationchange", this.checkIfPaginationInView);
// };

// Ajaxinate.prototype.addClickListener = function(){
//   if (!this.paginationElement) return;
//   this.nextPageLinkElement = this.paginationElement.querySelector("a");
//   this.clickActive = true;
//   if (this.nextPageLinkElement)
//     this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
// };

// Ajaxinate.prototype.stopMultipleClicks = function(event){
//   event.preventDefault();
//   if (this.clickActive && this.nextPageLinkElement){
//     this.nextPageLinkElement.innerHTML = this.settings.loadingText;
//     this.nextPageUrl = this.nextPageLinkElement.href;
//     this.clickActive = false;
//     this.loadMore();
//   }
// };

// Ajaxinate.prototype.checkIfPaginationInView = function(){
//   if (!this.paginationElement) return;
//   var rect = this.paginationElement.getBoundingClientRect();
//   var top = rect.top - this.settings.offset;
//   var bottom = rect.bottom + this.settings.offset;
//   if (top <= window.innerHeight && bottom >= 0){
//     this.nextPageLinkElement = this.paginationElement.querySelector("a");
//     this.removeScrollListener();
//     if (this.nextPageLinkElement){
//       this.nextPageLinkElement.innerHTML = this.settings.loadingText;
//       this.nextPageUrl = this.nextPageLinkElement.href;
//       this.loadMore();
//     }
//   }
// };

// Ajaxinate.prototype.loadMore = function(){
//   if (!this.nextPageUrl) return;
//   this.request = new XMLHttpRequest();
//   this.request.onreadystatechange = function(){
//     if (this.request.readyState === 4 && this.request.status === 200){
//       var doc = this.request.responseXML;
//       var newContainer = doc.querySelector(this.settings.container);
//       var newPagination = doc.querySelector(this.settings.pagination);

//       if (newContainer && this.containerElement) {
//         this.containerElement.insertAdjacentHTML("beforeend", newContainer.innerHTML);
//       }

//       if (newPagination && this.paginationElement) {
//         this.paginationElement.innerHTML = newPagination.innerHTML;
//       } else if (this.paginationElement) {
//         // if no pagination returned, remove pagination element to avoid errors
//         this.paginationElement.parentNode && this.paginationElement.parentNode.removeChild(this.paginationElement);
//         this.paginationElement = null;
//       }

//       if (typeof this.settings.callback === "function") {
//         this.settings.callback(doc);
//       }
//       // re-initialize to hook up listeners on any new pagination links
//       this.initialize();
//     }
//   }.bind(this);
//   this.request.open("GET", this.nextPageUrl);
//   this.request.responseType = "document";
//   this.request.send();
// };

// Ajaxinate.prototype.removeClickListener = function(){
//   if (this.nextPageLinkElement)
//     this.nextPageLinkElement.removeEventListener("click", this.stopMultipleClicks);
// };

// Ajaxinate.prototype.removeScrollListener = function(){
//   document.removeEventListener("scroll", this.checkIfPaginationInView);
//   window.removeEventListener("resize", this.checkIfPaginationInView);
//   window.removeEventListener("orientationchange", this.checkIfPaginationInView);
// };

// Ajaxinate.prototype.destroy = function(){
//   // call both to be safe; whichever is relevant will simply bail if not present
//   this.removeClickListener();
//   this.removeScrollListener();
//   return this;
// };

// /* ---------- Robust init logic for filters (MutationObserver + safe reinit) ---------- */

// var endlessScroll = null;
// var reinitTimer = null;
// var observer = null;

// // debounce helper
// function debounce(fn, wait) {
//   return function() {
//     clearTimeout(reinitTimer);
//     var args = arguments;
//     reinitTimer = setTimeout(function() {
//       fn.apply(null, args);
//     }, wait || 200);
//   };
// }

// function initAjaxinate() {
//   // destroy previous instance if present
//   if (endlessScroll && typeof endlessScroll.destroy === "function") {
//     try { endlessScroll.destroy(); } catch (e) { /* ignore */ }
//     endlessScroll = null;
//   }

//   // wait for container to exist - this handles cases where filters replace DOM
//   var maxAttempts = 20;
//   var attempt = 0;
//   var interval = setInterval(function() {
//     attempt++;
//     var container = document.querySelector('#AjaxinateContainer');
//     // If container exists and there's either pagination or we allow click-to-load creation
//     if (container) {
//       clearInterval(interval);
//       endlessScroll = new Ajaxinate({
//         container: '#AjaxinateContainer',
//         pagination: '#AjaxinatePagination',
//         callback: function(doc) {
//           // keep your lazy loader call
//           if (typeof lazyLoad === "function") lazyLoad();
//         }
//       });
//     } else if (attempt >= maxAttempts) {
//       clearInterval(interval);
//       // Give up — no container on page (possible edge case), nothing to init
//     }
//   }, 150);
// }

// // Safe observer: watches for DOM changes that usually happen when facets/filters update
// function observeForFacetChanges() {
//   // if already observing, don't recreate
//   if (observer) return;

//   var target = document.body;
//   if (!target) return;

//   observer = new MutationObserver(debounce(function(mutations) {
//     // small heuristic: if AjaxinateContainer or AjaxinatePagination added/changed -> init
//     var shouldReinit = false;
//     mutations.forEach(function(m) {
//       // check added/removed nodes quickly
//       m.addedNodes && m.addedNodes.forEach(function(node) {
//         if (!(node instanceof Element)) return;
//         if (node.matches && (node.matches('#AjaxinateContainer') || node.matches('#AjaxinatePagination'))) {
//           shouldReinit = true;
//         }
//         // also check descendants quickly
//         if (node.querySelector && (node.querySelector('#AjaxinateContainer') || node.querySelector('#AjaxinatePagination'))) {
//           shouldReinit = true;
//         }
//       });
//       m.removedNodes && m.removedNodes.forEach(function(node) {
//         if (!(node instanceof Element)) return;
//         if (node.matches && (node.matches('#AjaxinateContainer') || node.matches('#AjaxinatePagination'))) {
//           shouldReinit = true;
//         }
//       });
//     });

//     if (shouldReinit) {
//       initAjaxinate();
//     }
//   }, 250));

//   observer.observe(target, { childList: true, subtree: true, attributes: false });
// }

// // Init on DOM ready
// document.addEventListener("DOMContentLoaded", function() {
//   initAjaxinate();
//   observeForFacetChanges();
// });

// // Some themes/firewalled setups emit facet:update — handle it as well
// document.addEventListener("facet:update", function() {
//   // small delay to allow the theme to replace DOM fragments, but actual reinit is handled
//   // by the MutationObserver; still call initAjaxinate as a fallback
//   setTimeout(function() {
//     initAjaxinate();
//   }, 250);
// });




"use strict";

/* ---------- Ajaxinate Core ---------- */
var Ajaxinate = function(config){
  var settings = config || {},
      defaultSettings = {
        pagination: ".AjaxinatePagination",
        method: "scroll",
        container: ".AjaxinateLoop",
        offset: 0,
        loadingText: '<div class="loading"></div>',
        callback: null
      };
  this.settings = Object.assign(defaultSettings, settings);

  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.destroy = this.destroy.bind(this);

  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);
  this.initialize();
};

Ajaxinate.prototype.initialize = function(){
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  if (!this.containerElement) return;
  var initializers = { click: this.addClickListener, scroll: this.addScrollListeners };
  initializers[this.settings.method]();
};

Ajaxinate.prototype.addScrollListeners = function(){
  if (!this.paginationElement) return;

  // Scroll fallback
  document.addEventListener("scroll", this.checkIfPaginationInView);
  window.addEventListener("resize", this.checkIfPaginationInView);
  window.addEventListener("orientationchange", this.checkIfPaginationInView);

  // --- Intersection Observer addition ---
  if (window.IntersectionObserver) {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.nextPageLinkElement = this.paginationElement.querySelector("a");
          if (this.nextPageLinkElement) {
            this.nextPageLinkElement.innerHTML = this.settings.loadingText;
            this.nextPageUrl = this.nextPageLinkElement.href;
            this.loadMore();
          }
        }
      });
    }, { rootMargin: "200px 0px" }); // preload before user fully sees it

    this.observer.observe(this.paginationElement);
  }
};

Ajaxinate.prototype.addClickListener = function(){
  if (!this.paginationElement) return;
  this.nextPageLinkElement = this.paginationElement.querySelector("a");
  this.clickActive = true;
  if (this.nextPageLinkElement)
    this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
};

Ajaxinate.prototype.stopMultipleClicks = function(event){
  event.preventDefault();
  if (this.clickActive && this.nextPageLinkElement){
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function(){
  if (!this.paginationElement) return;
  var rect = this.paginationElement.getBoundingClientRect();
  var top = rect.top - this.settings.offset;
  var bottom = rect.bottom + this.settings.offset;
  if (top <= window.innerHeight && bottom >= 0){
    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    this.removeScrollListener();
    if (this.nextPageLinkElement){
      this.nextPageLinkElement.innerHTML = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = function(){
  if (!this.nextPageUrl) return;

  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function(){
    if (this.request.readyState === 4 && this.request.status === 200){
      var doc = this.request.responseXML;
      var newContainer = doc.querySelector(this.settings.container);
      var newPagination = doc.querySelector(this.settings.pagination);

      if (newContainer && this.containerElement) {
        this.containerElement.insertAdjacentHTML("beforeend", newContainer.innerHTML);
      }

      if (newPagination && this.paginationElement) {
        this.paginationElement.innerHTML = newPagination.innerHTML;
      } else if (this.paginationElement) {
        this.paginationElement.parentNode && this.paginationElement.parentNode.removeChild(this.paginationElement);
        this.paginationElement = null;
      }

      if (typeof this.settings.callback === "function") {
        this.settings.callback(doc);
      }

      this.initialize();
    }
  }.bind(this);

  this.request.open("GET", this.nextPageUrl);
  this.request.responseType = "document";
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function(){
  if (this.nextPageLinkElement)
    this.nextPageLinkElement.removeEventListener("click", this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function(){
  document.removeEventListener("scroll", this.checkIfPaginationInView);
  window.removeEventListener("resize", this.checkIfPaginationInView);
  window.removeEventListener("orientationchange", this.checkIfPaginationInView);
  if (this.observer) {
    this.observer.disconnect();
    this.observer = null;
  }
};

Ajaxinate.prototype.destroy = function(){
  this.removeClickListener();
  this.removeScrollListener();
  return this;
};

/* ---------- Safe reinit for filter/facet changes ---------- */
var endlessScroll = null;
var reinitTimer = null;
var observer = null;

function debounce(fn, wait) {
  return function() {
    clearTimeout(reinitTimer);
    var args = arguments;
    reinitTimer = setTimeout(function() {
      fn.apply(null, args);
    }, wait || 200);
  };
}

function initAjaxinate() {
  if (endlessScroll && typeof endlessScroll.destroy === "function") {
    try { endlessScroll.destroy(); } catch (e) {}
    endlessScroll = null;
  }

  var maxAttempts = 20;
  var attempt = 0;
  var interval = setInterval(function() {
    attempt++;
    var container = document.querySelector('#AjaxinateContainer');
    if (container) {
      clearInterval(interval);
      endlessScroll = new Ajaxinate({
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        callback: function(doc) {
          if (typeof lazyLoad === "function") lazyLoad();


            // --- Product count updater ---
            const searchTermsEl = document.querySelector("#search-terms-el");
            const countEls = document.querySelectorAll(".search-result-count.bottom");
            if (!searchTermsEl || !countEls.length) return;

            const searchTerms = searchTermsEl.dataset.searchTerms.toLowerCase().split(" ").filter(Boolean);
            let totalMatched = parseInt(countEls[0].dataset.count || 0);
            let newMatches = 0;

            const newProducts = doc.querySelectorAll(".product-card");
            newProducts.forEach((p) => {
              const title = p.querySelector(".product-title")?.innerText.toLowerCase() || "";
              if (searchTerms.every((t) => title.includes(t))) newMatches++;
            });

            totalMatched += newMatches;

            countEls.forEach((el) => {
              el.dataset.count = totalMatched;
              el.innerHTML = `Showing ${totalMatched} results for “${searchTerms.join(" ")}”`;
            });
        }
      });
    } else if (attempt >= maxAttempts) {
      clearInterval(interval);
    }
  }, 150);
}

function observeForFacetChanges() {
  if (observer) return;
  var target = document.body;
  if (!target) return;

  observer = new MutationObserver(debounce(function(mutations) {
    var shouldReinit = false;
    mutations.forEach(function(m) {
      m.addedNodes && m.addedNodes.forEach(function(node) {
        if (!(node instanceof Element)) return;
        if (node.matches && (node.matches('#AjaxinateContainer') || node.matches('#AjaxinatePagination'))) {
          shouldReinit = true;
        }
        if (node.querySelector && (node.querySelector('#AjaxinateContainer') || node.querySelector('#AjaxinatePagination'))) {
          shouldReinit = true;
        }
      });
    });
    if (shouldReinit) initAjaxinate();
  }, 250));

  observer.observe(target, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", function() {
  initAjaxinate();
  observeForFacetChanges();
});

document.addEventListener("facet:update", function() {
  setTimeout(function() {
    initAjaxinate();
  }, 250);
});
